import { render } from "./AdminShell.vue?vue&type=template&id=f0cdbb38&scoped=true"
import script from "./AdminShell.vue?vue&type=script&lang=js"
export * from "./AdminShell.vue?vue&type=script&lang=js"

import "./AdminShell.vue?vue&type=style&index=0&id=f0cdbb38&scoped=true&lang=css"
import "./AdminShell.vue?vue&type=style&index=1&id=f0cdbb38&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0cdbb38"]])

export default __exports__